<template>
  <div
      :data-testid="props.dataTestid+'_topbrands_main'"
      :id="random_id"
      v-if="brands_data.length > 0"
      class="flex items-center justify-start gap-2 lg:gap-4 overflow-auto hide-scroll-bar"
  >
      <div
          v-for="(item, index) in brands_data"
          :key="item"
      >
        <TsCardBrandProduct
            :productImage="item.image"
            :appendClass="twMerge('max-w-max py-2 px-3')"
            :productImageBrand="item.logo"
            :productLink="item.link"
            :backgroundColor="item.backgroundColor"
        />
      </div>
  </div>
</template>

<script setup lang="ts">
import {twMerge} from 'tailwind-merge'
import {useRandomUUID} from "~/composables/useRandomUUID";
import {ref, computed, onMounted} from "vue"

type Props = {
  appendClass?: string;
  dataTestid?: string;
  data?: object[];
};

const TsCardBrandProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardBrandProduct.vue')
);

const brands_data = computed(() => {
  return Array.isArray(props.data) && props.data.length > 0 ? props.data.slice(0, 7) : [];
})

const random_id = ref('')
const props = withDefaults(defineProps<Props>(), {})
// 
onMounted(() => {
  random_id.value = useRandomUUID()
})

</script>



